import React from "react";
import {
  Box,
  Grid,
  CardContent,
  Skeleton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
} from "@mui/material";
import { StandardCard } from "../../../../components/Cards";
import { KeyMetricsSkeleton } from "./KeyMetricsSkeleton";

interface TopPerformersSkeletonProps {
  venueCount?: number;
  serviceCount?: number;
}

export const TopPerformersSkeleton: React.FC<TopPerformersSkeletonProps> = ({
  venueCount = 3,
  serviceCount = 5,
}) => {
  return (
    <Grid container spacing={3}>
      {/* Top Venues Skeleton */}
      <Grid item xs={12} md={4}>
        <StandardCard>
          <CardContent>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Skeleton
                variant="circular"
                width={24}
                height={24}
                sx={{ mr: 1 }}
              />
              <Skeleton variant="text" width={150} height={32} />
            </Box>
            <List>
              {Array.from({ length: venueCount }).map((_, index) => (
                <ListItem key={index} sx={{ px: 0 }}>
                  <ListItemAvatar>
                    <Skeleton variant="circular" width={40} height={40} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Skeleton variant="text" width={120} height={20} />
                    }
                    secondary={
                      <Skeleton variant="text" width={100} height={16} />
                    }
                  />
                  <ListItemSecondaryAction>
                    <Skeleton
                      variant="rectangular"
                      width={60}
                      height={24}
                      sx={{ borderRadius: 12 }}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </CardContent>
        </StandardCard>
      </Grid>

      {/* Top Services Skeleton */}
      <Grid item xs={12} md={4}>
        <StandardCard>
          <CardContent>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Skeleton
                variant="circular"
                width={24}
                height={24}
                sx={{ mr: 1 }}
              />
              <Skeleton variant="text" width={150} height={32} />
            </Box>
            <List>
              {Array.from({ length: serviceCount }).map((_, index) => (
                <ListItem key={index} sx={{ px: 0 }}>
                  <ListItemAvatar>
                    <Skeleton variant="circular" width={40} height={40} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Skeleton variant="text" width={120} height={20} />
                    }
                    secondary={
                      <Skeleton variant="text" width={100} height={16} />
                    }
                  />
                  <ListItemSecondaryAction>
                    <Skeleton
                      variant="rectangular"
                      width={60}
                      height={24}
                      sx={{ borderRadius: 12 }}
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          </CardContent>
        </StandardCard>
      </Grid>

      {/* Key Metrics Skeleton */}
      <Grid item xs={12} md={4}>
        <KeyMetricsSkeleton />
      </Grid>
    </Grid>
  );
};
